import { observer } from 'mobx-react';
import { NotTranslated, T } from '../../../../../../../../../Translations';

export interface Props {
  name: string;
}

function Collection({ name }: Props) {
  return (
    <>
      <label className="py-1.5 text-sm font-semibold text-gray-800 block">
        <T kind="Collection" />
      </label>
      <div className="flex flex-col mb-2">
        <select
          className="w-full bg-none rounded border-[#BEC0C580] bg-[#BEC0C580] opacity-50"
          disabled
        >
          <option>
            <NotTranslated text={name} />
          </option>
        </select>
      </div>
    </>
  );
}

export default observer(Collection);
